// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3sMnV","inner":"Footer_inner__39Yjl"};